import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { batchedSubscribe } from 'redux-batched-subscribe';
import { unstable_batchedUpdates } from 'react-dom';
import Graphql from './graphql';
import WebNotifications from '../channels/web_notifications';
import RootReducer from '../reducers/index';

const ConversationsApp = {};

ConversationsApp.createStore = function(initialData) {
  var middlewares = [thunk];

  if (window.Voray.env === 'development') {
    ConversationsApp.Logger = createLogger();
    middlewares.push(ConversationsApp.Logger);
  }

  if (typeof jQuery !== 'undefined') {
    Graphql.setup();
  }

  ConversationsApp.Store = createStore(
    RootReducer,
    initialData,
    compose(
      applyMiddleware(...middlewares),
      batchedSubscribe(unstable_batchedUpdates)
    )
  );

  WebNotifications.subscribe();

  return ConversationsApp.Store;
};

export default ConversationsApp;
